import { ReactNode, useEffect, useRef } from 'react'

import IconAlertCircle from 'src/icons/IconAlertCircle'

interface AlertProps {
  title?: string
  description?: string | ReactNode
  variant?: 'brand' | 'warning' | 'error'
  actionButton?: ReactNode
  className?: string
}

const StyledAlert = ({
  title,
  description,
  variant = 'brand',
  actionButton,
  className = '',
}: AlertProps) => {
  const colorVariant = {
    bg: 'bg-doubleNickel-brand-25',
    icon: 'stroke-doubleNickel-brand-500',
    text: 'text-doubleNickel-brand-500',
  }

  if (variant === 'warning') {
    colorVariant.bg = 'bg-doubleNickel-warning-50'
    colorVariant.icon = 'stroke-doubleNickel-warning-500'
    colorVariant.text = 'text-doubleNickel-warning-500'
  } else if (variant === 'error') {
    colorVariant.bg = 'bg-doubleNickel-error-50'
    colorVariant.icon = 'stroke-doubleNickel-error-500'
    colorVariant.text = 'text-doubleNickel-error-500'
  }

  const textRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (textRef.current) {
      textRef.current.scrollTop = 0
    }
  }, [title, description])

  return (
    <div
      className={`flex flex-col items-center gap-6 rounded-lg sm:flex-row ${colorVariant.bg} p-4 ${className}`}
    >
      <div>
        <IconAlertCircle className={`fill-none ${colorVariant.icon}`} />
      </div>
      <div
        ref={textRef}
        className={`flex flex-col justify-start gap-1 ${colorVariant.text} max-h-[120px] flex-1 overflow-auto`}
      >
        {title && (
          <div className="sm:text-md text-sm font-semibold">{title}</div>
        )}
        {description && <div className="sm:text-md text-sm">{description}</div>}
      </div>
      {actionButton && <div className="flex-shrink-0">{actionButton}</div>}
    </div>
  )
}

export default StyledAlert
